import React from 'react';
import cn from 'classnames';

var styles = {"header":"calendar__header_1mvlw","withShadow":"calendar__withShadow_1mvlw"};
require('./index.css');

var Header = function (_a) {
    var _b;
    var _c = _a.view, view = _c === void 0 ? 'full' : _c, withShadow = _a.withShadow, children = _a.children, className = _a.className;
    return (React.createElement("div", { className: cn(styles.header, className, (_b = {},
            _b[styles.monthOnly] = view === 'month-only',
            _b[styles.withShadow] = withShadow,
            _b)), "aria-live": 'polite' }, children));
};

export { Header };
